"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyAccessPointUnlockRequest = verifyAccessPointUnlockRequest;
var hasura_1 = require("../hasura");
var timetable_verification_1 = require("../timetable-verification");
var utils_1 = require("../utils");
var selectAccessPointSchedulesByUserRoles_1 = require("./selectAccessPointSchedulesByUserRoles");
var selectValidAccessPointUserRoles_1 = require("./selectValidAccessPointUserRoles");
function verifyAccessPointUnlockRequest(args) {
    var accessPoint = args.accessPoint;
    var timezone = accessPoint.property.timezone;
    var validUserRoles = (0, selectValidAccessPointUserRoles_1.selectValidAccessPointUserRoles)(accessPoint, args.userRoles);
    if (!validUserRoles.length) {
        throw new utils_1.ExposedError('You do not have access to this entry point');
    }
    if (accessPoint.activeEmergencyPlan === hasura_1.EmergencyPlan_enum.LOCKDOWN) {
        validUserRoles = validUserRoles.filter(function (u) { return (u.userRolePermissions.some(function (urp) { return (urp.permissionKey === hasura_1.PermissionKey_enum.AccessPoint_BypassEmergencyLockdown); })); });
    }
    if (!validUserRoles.length) {
        throw new utils_1.ExposedError('This entry point is currently on lockdown');
    }
    validUserRoles = validUserRoles.filter(function (u) { return (!u.schedule || (0, timetable_verification_1.isDateAllowedOnTimetable)(new Date(), u.schedule, timezone)); });
    if (!validUserRoles.length) {
        throw new utils_1.ExposedError('You cannot access this entry point at this time');
    }
    var accessPointSchedules = (0, selectAccessPointSchedulesByUserRoles_1.selectAccessPointSchedulesByUserRoles)({
        accessPoint: accessPoint,
        userRoles: validUserRoles,
        includeReservationOnly: false,
    });
    if (accessPointSchedules && !(0, timetable_verification_1.isDateAllowedOnTimetable)(new Date(), accessPointSchedules, timezone)) {
        throw new utils_1.ExposedError('You cannot access this entry point at this time');
    }
    return { validUserRoles: validUserRoles, accessPointSchedules: accessPointSchedules };
}
//# sourceMappingURL=verifyAccessPointUnlockRequest.js.map